/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=Index&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=Index&lang=js"

import "./index.vue?vue&type=style&index=0&id=05c1e775&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05c1e775"]])

export default __exports__